import { render } from "./Stay.vue?vue&type=template&id=9b25768a"
import script from "./Stay.vue?vue&type=script&lang=js"
export * from "./Stay.vue?vue&type=script&lang=js"
script.render = render

export default script